import { R_CONTACT_US } from '../routes';

const ContactUs = () => import(/* webpackChunkName: "ContactUs" */ '@/views/ContactUs');

export default {
  name: R_CONTACT_US,
  meta: {
    title: 'Contact us',
  },
  path: '/contact-us',
  component: ContactUs,
};
